import styles from "./SideImageSection.module.css";
import { LocationInfo } from "../../../lib/LocationInfo";

function SideImageSection({ className }) {
  const locationInfo = new LocationInfo();

  return (
    <section
      className={`${className} 
       ${
         locationInfo.isAmerica()
           ? styles.sideImageSectionRegister_us
           : styles.sideImageSectionRegister_eu
       } ${styles.sideImageSection}`}
    ></section>
  );
}

export default SideImageSection;
